import { userChangePasswordSuccess, userChangePasswordError } from "./reducer"
import * as AuthApi from "../../../services/authApi";

export const userChangePassword = (data, { router }) => async (dispatch) => {
  try {
    const response = await AuthApi.changePassword({
      currentPassword: data.currentPassword,
      password: data.password,
      passwordConfirmation: data.passwordConfirmation
    });


    if (response) {
        dispatch(userChangePasswordSuccess(
            "Password changed successfully. You will be logged out shortly."
        ));

        setTimeout(() => {
            router.navigate("/logout");
        }, 1500);
    } else {
        dispatch(userChangePasswordError(response.error));
    }
  } catch (changeError: any) {
      dispatch(userChangePasswordError(
        changeError.response?.data?.error || "An error occurred while changing password"
      ));
  }
}